export const TKeyPrivacy = {
  PRIVACY_POLICY: "PRIVACY_POLICY",
  PRIVACY_DATE: "PRIVACY_DATE",
  PRIVACY_DESCRIPTION: "PRIVACY_DESCRIPTION",
  PRIVACY_SUMMARY_TITLE: "PRIVACY_SUMMARY_TITLE",
  PRIVACY_SUMMARY_TEXT: "PRIVACY_SUMMARY_TEXT",
  PRIVACY_1_TITLE: "PRIVACY_1_TITLE",
  PRIVACY_1_TEXT: "PRIVACY_1_TEXT",
  PRIVACY_1_LI_BOLD_1: "PRIVACY_1_LI_BOLD_1",
  PRIVACY_1_LI_TEXT_1: "PRIVACY_1_LI_TEXT_1",
  PRIVACY_1_LI_BOLD_2: "PRIVACY_1_LI_BOLD_2",
  PRIVACY_1_LI_TEXT_2: "PRIVACY_1_LI_TEXT_2",
  PRIVACY_1_LI_BOLD_3: "PRIVACY_1_LI_BOLD_3",
  PRIVACY_1_LI_TEXT_3: "PRIVACY_1_LI_TEXT_3",
  PRIVACY_1_LI_BOLD_4: "PRIVACY_1_LI_BOLD_4",
  PRIVACY_1_LI_TEXT_4: "PRIVACY_1_LI_TEXT_4",
  PRIVACY_1_LI_BOLD_5: "PRIVACY_1_LI_BOLD_5",
  PRIVACY_1_LI_TEXT_5: "PRIVACY_1_LI_TEXT_5",
  PRIVACY_2_TITLE: "PRIVACY_2_TITLE",
  PRIVACY_2_1_TITLE: "PRIVACY_2_1_TITLE",
  PRIVACY_2_1_TEXT: "PRIVACY_2_1_TEXT",
  PRIVACY_2_1_LI_1: "PRIVACY_2_1_LI_1",
  PRIVACY_2_1_LI_2: "PRIVACY_2_1_LI_2",
  PRIVACY_2_1_LI_3: "PRIVACY_2_1_LI_3",
  PRIVACY_2_1_LI_4: "PRIVACY_2_1_LI_4",
  PRIVACY_2_1_TEXT_2: "PRIVACY_2_1_TEXT_2",
  PRIVACY_2_2_TITLE: "PRIVACY_2_2_TITLE",
  PRIVACY_2_2_TEXT: "PRIVACY_2_2_TEXT",
  PRIVACY_2_2_LI_1: "PRIVACY_2_2_LI_1",
  PRIVACY_2_2_LI_2: "PRIVACY_2_2_LI_2",
  PRIVACY_2_2_LI_3: "PRIVACY_2_2_LI_3",
  PRIVACY_2_2_LI_4: "PRIVACY_2_2_LI_4",
  PRIVACY_2_2_LI_5: "PRIVACY_2_2_LI_5",
  PRIVACY_2_2_LI_6: "PRIVACY_2_2_LI_6",
  PRIVACY_2_2_LI_7: "PRIVACY_2_2_LI_7",
  PRIVACY_2_2_TEXT_2: "PRIVACY_2_2_TEXT_2",
  PRIVACY_2_2_TEXT_3: "PRIVACY_2_2_TEXT_3",
  PRIVACY_2_2_TEXT_4: "PRIVACY_2_2_TEXT_4",
  PRIVACY_2_3_TITLE: "PRIVACY_2_3_TITLE",
  PRIVACY_2_3_TEXT: "PRIVACY_2_3_TEXT",
  PRIVACY_2_3_LI_1: "PRIVACY_2_3_LI_1",
  PRIVACY_2_3_LI_2: "PRIVACY_2_3_LI_2",
  PRIVACY_2_3_LI_3: "PRIVACY_2_3_LI_3",
  PRIVACY_2_3_LI_4: "PRIVACY_2_3_LI_4",
  PRIVACY_2_4_TITLE: "PRIVACY_2_4_TITLE",
  PRIVACY_2_4_TEXT: "PRIVACY_2_4_TEXT",
  PRIVACY_2_5_TITLE: "PRIVACY_2_5_TITLE",
  PRIVACY_2_5_TEXT: "PRIVACY_2_5_TEXT",
  PRIVACY_2_5_LI_1: "PRIVACY_2_5_LI_1",
  PRIVACY_2_5_LI_2: "PRIVACY_2_5_LI_2",
  PRIVACY_2_5_LI_3: "PRIVACY_2_5_LI_3",
  PRIVACY_2_5_LI_4: "PRIVACY_2_5_LI_4",
  PRIVACY_2_5_LI_5: "PRIVACY_2_5_LI_5",
  PRIVACY_2_5_TEXT_2: "PRIVACY_2_5_TEXT_2",
  PRIVACY_2_6_TITLE: "PRIVACY_2_6_TITLE",
  PRIVACY_2_6_TEXT: "PRIVACY_2_6_TEXT",
  PRIVACY_2_7_TITLE: "PRIVACY_2_7_TITLE",
  PRIVACY_2_7_TEXT: "PRIVACY_2_7_TEXT",
  PRIVACY_3_TITLE: "PRIVACY_3_TITLE",
  PRIVACY_3_TEXT: "PRIVACY_3_TEXT",
  PRIVACY_3_LI_BOLD_1: "PRIVACY_3_LI_BOLD_1",
  PRIVACY_3_LI_TEXT_1: "PRIVACY_3_LI_TEXT_1",
  PRIVACY_3_LI_BOLD_2: "PRIVACY_3_LI_BOLD_2",
  PRIVACY_3_LI_TEXT_2: "PRIVACY_3_LI_TEXT_2",
  PRIVACY_3_LI_BOLD_3: "PRIVACY_3_LI_BOLD_3",
  PRIVACY_3_LI_TEXT_3: "PRIVACY_3_LI_TEXT_3",
  PRIVACY_3_LI_BOLD_4: "PRIVACY_3_LI_BOLD_4",
  PRIVACY_3_LI_TEXT_4: "PRIVACY_3_LI_TEXT_4",
  PRIVACY_3_LI_BOLD_5: "PRIVACY_3_LI_BOLD_5",
  PRIVACY_3_LI_TEXT_5: "PRIVACY_3_LI_TEXT_5",
  PRIVACY_3_LI_BOLD_6: "PRIVACY_3_LI_BOLD_6",
  PRIVACY_3_LI_TEXT_6: "PRIVACY_3_LI_TEXT_6",
  PRIVACY_3_LI_BOLD_7: "PRIVACY_3_LI_BOLD_7",
  PRIVACY_3_LI_TEXT_7: "PRIVACY_3_LI_TEXT_7",
  PRIVACY_3_LI_BOLD_8: "PRIVACY_3_LI_BOLD_8",
  PRIVACY_3_LI_TEXT_8: "PRIVACY_3_LI_TEXT_8",
  PRIVACY_3_NOTE: "PRIVACY_3_NOTE",
  PRIVACY_4_TITLE: "PRIVACY_4_TITLE",
  PRIVACY_4_TEXT: "PRIVACY_4_TEXT",
  PRIVACY_4_1_TITLE: "PRIVACY_4_1_TITLE",
  PRIVACY_4_1_TEXT: "PRIVACY_4_1_TEXT",
  PRIVACY_4_2_TITLE: "PRIVACY_4_2_TITLE",
  PRIVACY_4_2_TEXT: "PRIVACY_4_2_TEXT",
  PRIVACY_4_3_TITLE: "PRIVACY_4_3_TITLE",
  PRIVACY_4_3_TEXT: "PRIVACY_4_3_TEXT",
  PRIVACY_4_4_TITLE: "PRIVACY_4_4_TITLE",
  PRIVACY_4_4_TEXT: "PRIVACY_4_4_TEXT",
  PRIVACY_4_5_TITLE: "PRIVACY_4_5_TITLE",
  PRIVACY_4_5_TEXT: "PRIVACY_4_5_TEXT",
  PRIVACY_4_6_TITLE: "PRIVACY_4_6_TITLE",
  PRIVACY_4_6_TEXT: "PRIVACY_4_6_TEXT",
  PRIVACY_4_7_TITLE: "PRIVACY_4_7_TITLE",
  PRIVACY_4_7_TEXT: "PRIVACY_4_7_TEXT",
  PRIVACY_4_7_LI_BOLD_1: "PRIVACY_4_7_LI_BOLD_1",
  PRIVACY_4_7_LI_TEXT_1: "PRIVACY_4_7_LI_TEXT_1",
  PRIVACY_4_7_LI_BOLD_2: "PRIVACY_4_7_LI_BOLD_2",
  PRIVACY_4_7_LI_TEXT_2: "PRIVACY_4_7_LI_TEXT_2",
  PRIVACY_4_7_LI_BOLD_3: "PRIVACY_4_7_LI_BOLD_3",
  PRIVACY_4_7_LI_TEXT_3: "PRIVACY_4_7_LI_TEXT_3",
  PRIVACY_4_7_NOTE: "PRIVACY_4_7_NOTE",
  PRIVACY_5_TITLE: "PRIVACY_5_TITLE",
  PRIVACY_5_TEXT: "PRIVACY_5_TEXT",
  PRIVACY_6_TITLE: "PRIVACY_6_TITLE",
  PRIVACY_6_LI_BOLD_1: "PRIVACY_6_LI_BOLD_1",
  PRIVACY_6_LI_TEXT_1: "PRIVACY_6_LI_TEXT_1",
  PRIVACY_6_LI_BOLD_2: "PRIVACY_6_LI_BOLD_2",
  PRIVACY_6_LI_TEXT_2: "PRIVACY_6_LI_TEXT_2",
  PRIVACY_6_LI_BOLD_3: "PRIVACY_6_LI_BOLD_3",
  PRIVACY_6_LI_TEXT_3: "PRIVACY_6_LI_TEXT_3",
  PRIVACY_6_LI_BOLD_4: "PRIVACY_6_LI_BOLD_4",
  PRIVACY_6_LI_TEXT_4: "PRIVACY_6_LI_TEXT_4",
  PRIVACY_6_LI_BOLD_5: "PRIVACY_6_LI_BOLD_5",
  PRIVACY_6_LI_TEXT_5: "PRIVACY_6_LI_TEXT_5",
  PRIVACY_6_LI_BOLD_6: "PRIVACY_6_LI_BOLD_6",
  PRIVACY_6_LI_TEXT_6: "PRIVACY_6_LI_TEXT_6",
  PRIVACY_7_TITLE: "PRIVACY_7_TITLE",
  PRIVACY_7_TEXT: "PRIVACY_7_TEXT",
  PRIVACY_7_LI_1: "PRIVACY_7_LI_1",
  PRIVACY_7_LI_2: "PRIVACY_7_LI_2",
  PRIVACY_7_LI_3: "PRIVACY_7_LI_3",
  PRIVACY_7_LI_4: "PRIVACY_7_LI_4",
  PRIVACY_7_LI_5: "PRIVACY_7_LI_5",
  PRIVACY_7_NOTE: "PRIVACY_7_NOTE",
  PRIVACY_8_TITLE: "PRIVACY_8_TITLE",
  PRIVACY_8_TEXT: "PRIVACY_8_TEXT",
  PRIVACY_8_LI_BOLD_1: "PRIVACY_8_LI_BOLD_1",
  PRIVACY_8_LI_TEXT_1: "PRIVACY_8_LI_TEXT_1",
  PRIVACY_8_LI_BOLD_2: "PRIVACY_8_LI_BOLD_2",
  PRIVACY_8_LI_TEXT_2: "PRIVACY_8_LI_TEXT_2",
  PRIVACY_8_LI_BOLD_3: "PRIVACY_8_LI_BOLD_3",
  PRIVACY_8_LI_TEXT_3: "PRIVACY_8_LI_TEXT_3",
  PRIVACY_8_LI_BOLD_4: "PRIVACY_8_LI_BOLD_4",
  PRIVACY_8_LI_TEXT_4: "PRIVACY_8_LI_TEXT_4",
  PRIVACY_8_LI_BOLD_5: "PRIVACY_8_LI_BOLD_5",
  PRIVACY_8_LI_TEXT_5: "PRIVACY_8_LI_TEXT_5",
  PRIVACY_8_LI_BOLD_6: "PRIVACY_8_LI_BOLD_6",
  PRIVACY_8_LI_TEXT_6: "PRIVACY_8_LI_TEXT_6",
  PRIVACY_8_CONTACT: "PRIVACY_8_CONTACT",
  PRIVACY_8_CNIL: "PRIVACY_8_CNIL",
  PRIVACY_9_TITLE: "PRIVACY_9_TITLE",
  PRIVACY_9_TEXT: "PRIVACY_9_TEXT",
  PRIVACY_9_LI_BOLD_1: "PRIVACY_9_LI_BOLD_1",
  PRIVACY_9_LI_TEXT_1: "PRIVACY_9_LI_TEXT_1",
  PRIVACY_9_LI_BOLD_2: "PRIVACY_9_LI_BOLD_2",
  PRIVACY_9_LI_TEXT_2: "PRIVACY_9_LI_TEXT_2",
  PRIVACY_9_NOTE: "PRIVACY_9_NOTE",
  PRIVACY_10_TITLE: "PRIVACY_10_TITLE",
  PRIVACY_10_TEXT: "PRIVACY_10_TEXT",
  PRIVACY_10_LI_1: "PRIVACY_10_LI_1",
  PRIVACY_10_LI_2: "PRIVACY_10_LI_2",
  PRIVACY_10_LI_3: "PRIVACY_10_LI_3",
  PRIVACY_11_TITLE: "PRIVACY_11_TITLE",
  PRIVACY_11_TEXT: "PRIVACY_11_TEXT",
  PRIVACY_11_TEXT_2: "PRIVACY_11_TEXT_2",
  PRIVACY_12_TITLE: "PRIVACY_12_TITLE",
  PRIVACY_12_TEXT: "PRIVACY_12_TEXT",
  PRIVACY_13_TITLE: "PRIVACY_13_TITLE",
  PRIVACY_13_TEXT: "PRIVACY_13_TEXT",
  PRIVACY_14_TITLE: "PRIVACY_14_TITLE",
  PRIVACY_14_TEXT: "PRIVACY_14_TEXT",
  PRIVACY_14_LI_1: "PRIVACY_14_LI_1",
  PRIVACY_14_LI_2: "PRIVACY_14_LI_2",
  PRIVACY_14_LI_3: "PRIVACY_14_LI_3",
  PRIVACY_14_LI_4: "PRIVACY_14_LI_4",
  PRIVACY_14_LI_5: "PRIVACY_14_LI_5",
  PRIVACY_14_LI_6: "PRIVACY_14_LI_6",
  PRIVACY_14_LI_7: "PRIVACY_14_LI_7",
  PRIVACY_14_LI_8: "PRIVACY_14_LI_8",
  PRIVACY_14_NOTE: "PRIVACY_14_NOTE",
  PRIVACY_END_TEXT: "PRIVACY_END_TEXT",
} as const;
